import {useSearchParams} from 'react-router-dom';
import {useProjectStore} from '@/store/projectStore';
import type {ProjectId} from '@/types';

/**
 * 获取当前 projectId
 * 优先级：URL 参数 > store
 */
export const useProjectId = (): ProjectId => {
    const [searchParams] = useSearchParams();
    const storeProjectId = useProjectStore((s) => s.currentProjectId);
    return searchParams.get('projectId') || storeProjectId || '';
};
